import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet, Row, Col, Button } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'
import * as Sections from './sections'
import * as UsuarioService from 'services/usuario.service'

const portletBreadcrumbs = [{ name: 'Asignar Documentos' }]

const IDS_SECTIONS = {
  LISTA: 'LISTA',
  NUEVO_CON_DOC: 'NUEVO_CON_DOC',
  NUEVO_SIN_DOC: 'NUEVO_SIN_DOC'
}

const AsignarDocumentosTrabajadoresPage = () => {
  const __zariContext = React.useContext(ZariContext)

  const [activeSection, setActiveSection] = React.useState('')
  const [idTituloViatico, setIdTituloViatico] = React.useState('')
  const [idUsuario, setIdUsuario] = React.useState('')
  const [nombreUsuario, setNombreUsuario] = React.useState('')

  const editarDataRef = React.useRef({})

  React.useEffect(() => {
    UsuarioService.obtenerUsuarioSelfIdNombresApellidos()
      .then(({ data }) => {
        if (data && data._id) {
          setIdUsuario(data._id)
          setNombreUsuario(`${data.nombres} ${data.apellidos}`)
        }
      })
      .catch(() => {
        console.warn('⚠️ No se pudo cargar el usuario logueado.')
      })
  }, [])

  const ocultarSections = React.useCallback(() => {
    editarDataRef.current = {}
    setActiveSection('')
  }, [])

  const mostrarListaSection = React.useCallback(() => {
    editarDataRef.current = {}
    setActiveSection(IDS_SECTIONS.LISTA)
  }, [])

  const mostrarNuevoDocSection = React.useCallback(data => {
    editarDataRef.current = data ?? {}
    setActiveSection(IDS_SECTIONS.NUEVO_CON_DOC)
  }, [])

  const mostrarNuevoSinDocSection = React.useCallback(data => {
    editarDataRef.current = data ?? {}
    setActiveSection(IDS_SECTIONS.NUEVO_SIN_DOC)
  }, [])

  const clickContinuar = React.useCallback(() => {
    editarDataRef.current = {}
    mostrarListaSection()
  }, [mostrarListaSection])

  const clickDescargarReporte = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte de entregas a rendir')
    AsientoContableService.descargarReporteEntregaARendirxIdUsuario(idUsuario)
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
        __zariContext.toast('success', 'Informe descargado.')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, idUsuario])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Asignar Documentos' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row>
            <Col md={4} className='zari-slim-form'>
              <FormGroups.TrabajadorFormGroup
                iValue={idUsuario}
                setIdUsuario={setIdUsuario}
                setNombreUsuario={setNombreUsuario}
                setIdTituloViatico={setIdTituloViatico}
                vNombreUsuario={nombreUsuario}
                ocultarSections={ocultarSections}
                showClearButton={false} 
              />
              <FormGroups.TituloViaticoFormGroup
                setIdTituloViatico={setIdTituloViatico}
                vIdUsuario={idUsuario}
                ocultarSections={ocultarSections}
              />
              <Row>
                <Col md={12} className='text-right'>
                  {idUsuario && (
                    <Button color='success' tiny outline onClick={clickDescargarReporte}>
                      Descargar informe
                    </Button>
                  )}
                  <Button id='button-asignarDocs-continuar-1' tiny onClick={clickContinuar}>
                    Continuar
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
      {!activeSection || !idTituloViatico || !idUsuario ? null : (
        <>
          {activeSection === IDS_SECTIONS.LISTA && (
            <Sections.ListaDocumentosSection
              idTituloViatico={idTituloViatico}
              idUsuario={idUsuario}
              mostrarNuevoDocSection={mostrarNuevoDocSection}
              mostrarNuevoSinDocSection={mostrarNuevoSinDocSection}
              editarData={editarDataRef.current}
            />
          )}
          {activeSection === IDS_SECTIONS.NUEVO_SIN_DOC && (
            <Sections.NuevoSinDocumentoSection
              idUsuario={idUsuario}
              idTituloViatico={idTituloViatico}
              mostrarListaSection={mostrarListaSection}
              editarData={editarDataRef.current}
            />
          )}
          {activeSection === IDS_SECTIONS.NUEVO_CON_DOC && (
            <Sections.NuevoConDocumentoSection
              idUsuario={idUsuario}
              idTituloViatico={idTituloViatico}
              mostrarListaSection={mostrarListaSection}
              editarData={editarDataRef.current}
            />
          )}
        </>
      )}
    </>
  )
}

export default React.memo(AsignarDocumentosTrabajadoresPage)
